import { render, staticRenderFns } from "./StatementOfUse.vue?vue&type=template&id=f83cfd02&"
import script from "./StatementOfUse.vue?vue&type=script&lang=js&"
export * from "./StatementOfUse.vue?vue&type=script&lang=js&"
import style0 from "./StatementOfUse.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "StatementOfUse.vue"
export default component.exports